if (!customElements.get('app-embed-styled')) {
  class AppEmbedStyled extends HTMLElement {
    constructor() {
      super();
      this.stylesId = this.dataset.stylesId;
      this.stylesApplied = false;
      this.observer = new MutationObserver(this.tryInjectStyles.bind(this));
    }

    connectedCallback() {
      this.tryInjectStyles();
      this.observer.observe(this, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.observer.disconnect();
    }

    getStyles() {
      if (!this.stylesId) return '';
      const template = document.getElementById(this.stylesId);
      return template ? template.textContent.trim() : '';
    }

    tryInjectStyles() {
      if (this.stylesApplied) return;
      const appEmbed = this.querySelector('#app-embed');
      if (!appEmbed || !appEmbed.shadowRoot) return;
      const target = appEmbed.shadowRoot.querySelector('#app-embed');
      if (!target) return;
      const styles = this.getStyles();
      if (!styles) return;
      const style = document.createElement('style');
      style.textContent = styles;
      target.appendChild(style);
      this.stylesApplied = true;
      this.observer.disconnect();
    }
  }
  customElements.define('app-embed-styled', AppEmbedStyled);
}
